import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects the legacy `/deals/:implementationId/files` path to `/deliverables`.
 * The tab was renamed to match the product vocabulary (a servicing cycle and its
 * deliverable are the same thing to the customer); this keeps older links and
 * bookmarks working instead of bouncing them to the portfolio catch-all.
 */
export const DealFilesRedirect = (): React.ReactElement => {
  const { implementationId } = useParams<{ implementationId: string }>();
  return (
    <Navigate to={`/deals/${implementationId ?? ''}/deliverables`} replace />
  );
};
